
      window.launchDarklyClientId = import.meta.env.VITE_MONOLITH_LAUNCH_DARKLY_CLIENT_ID
      import('./src/main.tsx')
    